if (!customElements.get('department-nav')) {
  class DepartmentNav extends HTMLElement {
    /** @type {NodeListOf<HTMLElement>} */
    #triggers;
    /** @type {NodeListOf<HTMLElement>} */
    #panels;

    connectedCallback() {
      this.#triggers = this.querySelectorAll('[data-dept]');
      this.#panels = this.querySelectorAll('[data-panel]');

      this.#triggers.forEach((trigger) => {
        trigger.addEventListener('pointerenter', this.#onSelect);
        trigger.addEventListener('focus', this.#onSelect);
        trigger.addEventListener('keydown', this.#onKeydown);
      });
    }

    disconnectedCallback() {
      this.#triggers?.forEach((trigger) => {
        trigger.removeEventListener('pointerenter', this.#onSelect);
        trigger.removeEventListener('focus', this.#onSelect);
        trigger.removeEventListener('keydown', this.#onKeydown);
      });
    }

    /**
     * @param {Event} event
     */
    #onSelect = (event) => {
      const trigger = event.currentTarget;
      if (!(trigger instanceof HTMLElement)) return;
      const id = trigger.dataset.dept;
      if (id) this.select(id);
    };

    /**
     * @param {KeyboardEvent} event
     */
    #onKeydown = (event) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault();
      const triggers = [...this.#triggers];
      const index = triggers.indexOf(event.currentTarget);
      if (index < 0) return;
      const next = event.key === 'ArrowDown'
        ? triggers[(index + 1) % triggers.length]
        : triggers[(index - 1 + triggers.length) % triggers.length];
      next?.focus();
      const id = next?.dataset.dept;
      if (id) this.select(id);
    };

    /**
     * @param {string} id
     */
    select(id) {
      this.#triggers.forEach((trigger) => {
        const on = trigger.dataset.dept === id;
        trigger.setAttribute('aria-selected', on ? 'true' : 'false');
        if (trigger.getAttribute('role') === 'tab') {
          trigger.tabIndex = on ? 0 : -1;
        }
      });
      this.#panels.forEach((panel) => {
        panel.hidden = panel.dataset.panel !== id;
      });
    }
  }

  customElements.define('department-nav', DepartmentNav);
}
